export const mapBrandByIndexLetter = (brands = []) => {
  const result = brands.reduce((acc, { product_source }) => {
    const { name } = product_source;
    const firstLetter = String(name[0]).toUpperCase();
    const isSpecialChar = new RegExp(/^[^A-Z]$/).test(firstLetter);
    const key = isSpecialChar ? "#" : firstLetter;

    if (!acc[key]) {
      acc[key] = [];
    }

    acc[key].push({ product_source });

    return acc;
  }, {});

  return result;
};
